import { TruncateString } from 'foundations-components/transitional/components/TruncateString';

// @ts-ignore ts-migrate FIXME
import { jsx as _jsx } from "react/jsx-runtime";
export default function transformSnippetsData(snippets) {
  return snippets ? snippets.get('results')
  // @ts-ignore ts-migrate FIXME
  .map(snippet => ({
    snippet: snippet.toJS(),
    searchText: snippet.get('shortcut'),
    text: snippet.get('name'),
    value: snippet.get('contentId'),
    help: /*#__PURE__*/_jsx(TruncateString, {
      children: snippet.getIn(['metadata', 'body'])
    })
  })).toArray() : [];
}